export default __webpack_public_path__ + "guide--imagery-sakurajima-960-1171fa24ef2aeba04d50e0666f9b46d1.webp";